export default {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: (theme) => theme.palette.background.paper,
  boxShadow: 24,
  p: 4,
};
